import { useImageAnnotatorContext } from "@msuite/image-annotator";
import { AnnotationToolbarOptions } from "./annotation-toolbar-options";
import { AnnotationToolbarTools } from "./annotation-toolbar-tools";

export function AnnotationToolbar() {
	/** Context */
	const context = useImageAnnotatorContext();

	/** Computed */
	const hasSelection = context.controller.hasSelection;

	/** Render */
	return (
		<div
			className="flex justify-center w-full"
			onClick={(e) => e.stopPropagation()}
		>
			<div className="relative rounded-2xl border-[0.5px] border-primary-700 bg-primary-950 p-2">
				{hasSelection ? <AnnotationToolbarOptions /> : <AnnotationToolbarTools />}
			</div>
		</div>
	);
}
